import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import CardContentActionTile from "../../../common/components/CardContentActionTile/CardContentActionTile";
import { Box } from "@mui/system";
import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import { Avatar, Typography } from "@mui/material";
import { fonts } from "../../../common/themes/themes";
import FeedbackDetailModalController from "../../../common/Modals/PerofomanceModals/FeedbackDetailModal/FeedbackDetailModalController";

interface propsType {
  trans?: any;
}
const FeedbackPresenter: React.FC<propsType> = ({ trans }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <CustomEditCard
        card_title={trans("Feedback")}
        card_height="310px"
        showEditButton={false}
      >
        <Box style={{ marginBottom: "24px" }} />

        <Box
          style={{
            backgroundColor: "#FAFAFA",
            display: "flex",
            alignItems: "center",
            padding: "0.5em",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() => setOpenModal(true)}
        >
          <Box>
            <Avatar />
          </Box>
          <Box style={{ marginLeft: "1em" }}>
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                color: "#000000",
                fontSize: "0.875em",
              }}
            >
              <span
                style={{
                  color: "#081735",
                  fontWeight: "bold",
                }}
              >
                Garrick Litle
              </span>{" "}
              gave feedbak about you
            </Typography>
          </Box>
        </Box>
        <Box style={{ marginTop: "0.5em" }} />
        <Box
          style={{
            backgroundColor: "#FAFAFA",
            display: "flex",
            alignItems: "center",
            padding: "0.5em",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() => setOpenModal(true)}
        >
          <Box>
            <Avatar />
          </Box>
          <Box style={{ marginLeft: "1em" }}>
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                color: "#000000",
                fontSize: "0.875em",
              }}
            >
              <span
                style={{
                  color: "#081735",
                  fontWeight: "bold",
                }}
              >
                Garrick Litle
              </span>{" "}
              gave feedbak about you
            </Typography>
          </Box>
        </Box>
      </CustomEditCard>
      {openModal && (
        <FeedbackDetailModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          trans={trans}
        />
      )}
    </div>
  );
};

export default FeedbackPresenter;
